import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Select from 'react-select';
import { Common, PopUpBox } from '../../../components';
import { styles, options, numberWithNoCommas, sw2Alert, alphabetOnly, alphabetAndNumberOnly } from '../../../utils/common';

import { actionMoneyComplete, actionMoneyForm3, actionSubmitForm22 } from '../../../store/application/actions';
import { actionAddressConfig, actionTracking } from '../../../store/common/actions';
import DropdownIndicator from '../../../components/Common/DropdownIndicator';
import moment from 'moment';

function StepForm3({ sessionId, formData, onCompleted, page }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {
        setValue,
        register,
        handleSubmit,
        setError,
        formState: { errors, isSubmitting },
    } = useForm();
    const [isVisibleInvalidToken, setIsVisibleInvalidToken] = useState(false);
    const [building, setBuilding] = useState('');
    const [estate, setEstate] = useState('');
    const [addressConfig, setAddressConfig] = useState(null);
    const [optionsDistrict, setOptionsDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState(null);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        getAddressConfig()
    }, []);

    const getAddressConfig = async () => {
        try {
            setLoading(true)
            const response = await dispatch(actionAddressConfig());
            console.log(response);
            if (response?.sts_code === 0) {
                setAddressConfig(response.content);
            } else {
                setAddressConfig({
                    area: options.area,
                    district_hk: options.district_hk,
                    district_kw: options.district_kw,
                    district_nt: options.district_nt,
                })
            }
            setLoading(false);
        } catch {
            setAddressConfig({
                area: options.area,
                district_hk: options.district_hk,
                district_kw: options.district_kw,
                district_nt: options.district_nt,
            })
        }
    }


    const onSubmit = async (data) => {
        const district = optionsDistrict.find(t => t.value === districtValue?.value);
        const province = addressConfig.area.find(t => t.value === data?.area);
        let addr_line1 = '';
        if (data?.addr_line1_room) {
            addr_line1 = 'RM ' + (data?.addr_line1_room ?? '')
                .replace(new RegExp('ROOM', 'g'), '')
                .replace(new RegExp('RM', 'g'), '')
                .replace(new RegExp('FLAT', 'g'), '')
                .replace(new RegExp('FLT', 'g'), '')
                .replace(new RegExp('UNIT', 'g'), '').trim();
        }
        if (data?.addr_line1_floor) {
            addr_line1 += ' ' + (data?.addr_line1_floor ?? '')
                .replace(new RegExp('FLOOR', 'g'), '')
                .replace(new RegExp('F', 'g'), '')
                .replace(new RegExp("/F", 'g'), '').trim()
                + '/F';
        }
        if (data?.addr_line1_block) {
            addr_line1 += ' BLK ' + data?.addr_line1_block
                .replace(new RegExp('BLK', 'g'), '')
                .replace(new RegExp('BLOCK', 'g'), '')
                .replace(new RegExp("BL", 'g'), '').trim();
        }
        console.log('addr_line1', addr_line1)
        if (addr_line1.length > 49 || data?.estate?.length > 49) {
            return sw2Alert('輸入的地址不可以超過50個字元');
        };
        let obj = {
            area: data?.area,
            city_id: district?.city_id,
            province_id: province?.province_id,
            city_id_tu: district?.tu_value,
            addr_line1: addr_line1,
            addr_line1_room: data?.addr_line1_room,
            addr_line1_floor: data?.addr_line1_floor,
            addr_line1_block: data?.addr_line1_block,
            addr_line2: data?.estate,
            property_type: data?.property_type,
            number_living_with: data?.number_living_with,
            property_owner: data?.property_owner,
            monthly_rent: numberWithNoCommas(data?.monthly_rent),
            session_id: sessionId,
            phone_number: formData['form1']['phone_number']
        };
        console.log(obj);
        const response = await dispatch(actionMoneyForm3(obj));
        if (response?.sts_code === 0 && formData) {
            const application_date = moment().format('YYYY-MM-DDTHH:mm:ss') + "Z";
            const { application_ip,
                application_browser,
                application_device,
                cust_gender,
                date_of_birth,
                education,
                email,
                first_name,
                last_name,
                hkid,
                loan_amount,
                loan_purpose,
                marriage_status,
                phone_number,
                check_box_1,
                check_box_2,
                check_box_1_time,
                check_box_2_time,
                agree_doc,
            } = formData['form1'];
            const {
                business_type,
                job_type,
                position,
                employment_type,
                receipt_way,
                monthly_income,
                payroll_method,
                mpf
            } = formData['form2'];

            const no_doc_loan_product = formData['form1']?.no_doc_loan_product || null;

            let data = {
                "application_date": application_date,
                "application_ip": application_ip,
                "application_browser": application_browser,
                "application_device": application_device,
                "first_vist_date": application_date,
                "apply_access_data": {
                    "access_data_id": "",
                    "access_referer": "No Referer",
                    "access_query": "string",
                    "utm_source": page === 'no-doc-loan' ? 'NoDocLoan' : 'MoneyHero',
                    "session_id": sessionId
                },
                "application_form_data": {
                    "addr_line1": obj.addr_line1,
                    "addr_line2": obj.addr_line2,
                    "business_type": business_type,
                    "city_id": obj.city_id,
                    "cust_gender": cust_gender,
                    "date_of_birth": parseInt(date_of_birth),
                    "education": education,
                    "email": email,
                    "employment_type": employment_type,
                    "first_name": first_name,
                    "hkid": hkid,
                    "job_type": job_type,
                    "last_name": last_name,
                    "loan_amount": parseInt(loan_amount),
                    "loan_purpose": loan_purpose,
                    "marriage_status": marriage_status,
                    "monthly_income": parseInt(monthly_income),
                    "monthly_rent": parseInt(obj.monthly_rent),
                    "mpf": mpf,
                    "number_living_with": obj.number_living_with,
                    "payroll_method": payroll_method,
                    "phone_number": phone_number,
                    "position": position,
                    "property_owner": obj.property_owner,
                    "property_type": obj.property_type,
                    "province_id": obj.province_id,
                    "receipt_way": receipt_way,
                    "check_box_1": check_box_1,
                    "check_box_1_time": check_box_1_time,
                    "check_box_2": check_box_2,
                    "check_box_2_time": check_box_2_time,
                    "agree_doc": JSON.parse(agree_doc)
                }
            }

            if (no_doc_loan_product && no_doc_loan_product === 'genz') {
                console.log('set loan_goods for genz no doc loan');
                data['application_form_data']['loan_goods'] = 'A0012';
            }

            const response = await dispatch(actionMoneyComplete(data))
            if (response?.sts_code === 0) {
                onCompleted({ status: true, data: { form3: obj } })
            }
        }
    };

    const beforeunload = (e) => {
        // const event = e || window.event;
        // if (event) {
        //     event.returnValue = 'Sure?';
        // }
        // return 'Sure?';
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('beforeunload', beforeunload);

        return () => {
            window.removeEventListener('beforeunload', beforeunload);
        };
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            {isVisibleInvalidToken && <PopUpBox.InvalidToken />}
            <Common.Loading isVisible={isSubmitting || isLoading} />
            <div className="bg-white lg:px-10">
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">區域</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('area', { required: true })}
                                onChange={(e) => {
                                    setValue('area', e.value);
                                    setError('area', null);
                                    setDistrictValue(null);
                                    setValue('district', null)
                                    switch (e.value) {
                                        case 'HK':
                                            setOptionsDistrict(addressConfig.district_hk);
                                            break;
                                        case 'KLN':
                                            setOptionsDistrict(addressConfig.district_kw);
                                            break;
                                        case 'NT':
                                            setOptionsDistrict(addressConfig.district_nt);
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                                options={addressConfig?.area}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors.area && errors.area.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">地區</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('district', { required: true })}
                                value={districtValue}
                                onChange={(e) => {
                                    setDistrictValue(e)
                                    setValue('district', e?.value)
                                    setError('district', null)
                                }}
                                options={optionsDistrict}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors.district && errors.district.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10 flex">
                        <div className="flex flex-col pr-2">
                            <p className="text-gray font-bold mb-2">單位</p>
                            <div className="flex items-center border-b border-primary">
                                <input
                                    {...register('addr_line1_room', { required: true })}
                                    onChange={(e) => {
                                        const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                        setValue('addr_line1_room', value)
                                    }}
                                    className="flex-1 px-1 outline-none text-primary w-full"
                                    placeholder="Room/Flat/Unit"
                                />
                            </div>
                            {errors.addr_line1_room && errors.addr_line1_room.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                        <div className="flex flex-col px-2">
                            <p className="text-gray font-bold mb-2">樓層</p>
                            <div className="flex items-center border-b border-primary">
                                <input
                                    {...register('addr_line1_floor', { required: false })}
                                    onChange={(e) => {
                                        const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                        setValue('addr_line1_floor', value)
                                    }}
                                    className="flex-1 px-1 outline-none text-primary w-full"
                                    placeholder="Floor"
                                />
                            </div>
                            {errors.addr_line1_floor && errors.addr_line1_floor.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                        <div className="flex flex-col pl-2">
                            <p className="text-gray font-bold mb-2">座數/大廈</p>
                            <div className="flex items-center border-b border-primary">
                                <input
                                    {...register('addr_line1_block', { required: false })}
                                    onChange={(e) => {
                                        const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                        setValue('addr_line1_block', value)
                                    }}
                                    className="flex-1 px-1 outline-none text-primary w-full"
                                    placeholder="Block"
                                />
                            </div>
                            {errors.addr_line1_block && errors.addr_line1_block.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                        </div>
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-gray font-bold mb-2">屋苑/街道</p>
                        <div className="flex items-center border-b border-primary">
                            <input
                                {...register('estate', { required: true })}
                                value={estate}
                                onChange={(e) => {
                                    const value = alphabetAndNumberOnly((e?.target?.value || '')).toUpperCase()
                                    setEstate(value)
                                }}
                                className="flex-1 px-2 outline-none text-primary w-full"
                                placeholder="(E.g. HAPPY EST)"
                            />
                        </div>
                        {errors.estate && errors.estate.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-2">房屋類型</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('property_type', { required: true })}
                                onChange={(e) => {
                                    setValue('property_type', e.value);
                                    setError('property_type', null);
                                }}
                                options={options.property_type}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors.property_type && errors.property_type.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">同住人數</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('number_living_with', { required: true })}
                                onChange={(e) => {
                                    setValue('number_living_with', e.value);
                                    setError('number_living_with', null);
                                }}
                                options={options.number_living_with}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors.number_living_with && errors.number_living_with.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                </div>
                <div className='p-3 flex max-md:flex-col'>
                    <div className="max-md:mb-6 lg:w-1/2 lg:pr-10">
                        <p className="text-xl text-gray font-bold mb-[16px]">持有人</p>
                        <div className="border-b border-primary relative">
                            <Select
                                placeholder="- 請選擇 -"
                                className="w-full"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                })}
                                styles={styles}
                                {...register('property_owner', { required: true })}
                                onChange={(e) => {
                                    setValue('property_owner', e.value);
                                    setError('property_owner', null);
                                }}
                                options={options.property_owner}
                                isSearchable={false}
                                components={{ DropdownIndicator }}
                            />
                        </div>
                        {errors.property_owner && errors.property_owner.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
                    </div>
                    <div className="lg:w-1/2 lg:pl-10">
                        <p className="text-xl text-gray font-bold mb-2">每月房租</p>
                        <p className="text-xs text-primary">(如果申請人無須交租，可輸入0) ​</p>
                        <Common.InputMoney zeroAllow={true} placeholder=" " register={register} title="monthly_rent" setError={setError} errors={errors} />
                    </div>
                </div>
                <div className="flex justify-center mb-4 mt-9">
                    <button disabled={isSubmitting} type="submit" className={`rounded-full text-white text-xl px-14 py-3 ${isSubmitting ? 'bg-mercury' : 'bg-primary'} button3`}>
                        提交申請
                    </button>
                </div>
            </div>
        </form>
    );
}

export default StepForm3;
